import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../data/store'
import { getNetworkResponseError, isStatusOK } from '../util/utill'
import { APIEndPoints } from './APIEndPoints'
import { apiConfig } from './config'
import { sendEventApiScheduled } from './sendEvent'

const responseParser = (data: any) => {
  console.log(data)
  if (isStatusOK(data) && data?.data?.sessionToken) {
    return data?.data
  } else {
    throw getNetworkResponseError(data?.data)
  }
}
const getUniqueDeviceSessionRequest = (agentUserId, channelId) => {
  return {
    agentUserId,
    deviceTimestamp: new Date().getTime(),
    deviceInfo: JSON.stringify(RootStore.agent.deviceInfo),
    deviceId: RootStore.agent.deviceInfo.id,
    latitude: RootStore.agent.deviceInfo?.latitude,
    longitude: RootStore.agent.deviceInfo?.longitude,
    channelId,
  }
}
export const getUniqueDeviceSession = (tokens: any, agentUserLoginId: string) => {
  const config = apiConfig(tokens)
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  config.headers.userIDToken = RootStore?.bcAppInfo?.userIdentifier

  const request: Request<{}> = {
    apiPath: `${APIEndPoints.getUniqueDeviceSession}`,
    method: 'POST',
    config: config,
    cache: false,
    body: getUniqueDeviceSessionRequest(agentUserLoginId, tokens?.CHANNEL_ID),
  }
  sendEventApiScheduled(tokens, request, {
    status: 'INITIATED',
  })

  return executeRequest(request)
    .then((data) => {
      console.log('HTAG DATA getAgentUserInformation', data)
      return responseParser(data)
    })
    .then((response) => {
      sendEventApiScheduled(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApiScheduled(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      return responseParser(err)
    })
}
